export default __webpack_public_path__ + "static/media/pirple.227db477.png";